export var uiBan = [
    'M8 2C4.69 2 2 4.71 2 8C2 11.31 4.69 14 8 14C11.29 14 14 11.31 14 8C14 4.71 11.29 2 8 2ZM4.3 11.7C2.34 9.77 2.27 6.65 4.03 4.59L11.41 11.97C9.35 13.73 6.23 13.66 4.3 11.7ZM11.94 11.44L4.56 4.06C6.62 2.29 9.74 2.36 11.68 4.32C13.64 6.26 13.71 9.38 11.94 11.44Z',
];
